import { RecurringInvoiceRepository } from '../domain/RecurringInvoiceRepository'
import { RecurringInvoiceListScreenData } from '../domain/RecurringInvoiceListScreenData'
import { EXPIRATION_TRANSLATOR } from '@/modules/facturae/domain/RecurringInvoiceContract'
import { InvoiceableRepository } from '../domain/InvoiceableRepository'
import { FileRepository } from '@/modules/shared/domain/FileRepository'


export class RecurringInvoiceListComponent {

    recurring_invoice_repository: RecurringInvoiceRepository
    screen_data: RecurringInvoiceListScreenData
    expiration_translator = EXPIRATION_TRANSLATOR
    invoiceable_repository: InvoiceableRepository
    file_repo: FileRepository

    constructor(
        recurring_invoice_repository:RecurringInvoiceRepository,
        screen_data:RecurringInvoiceListScreenData,
        invoiceable_repository: InvoiceableRepository,
        file_repo: FileRepository
    ) {
        this.recurring_invoice_repository = recurring_invoice_repository
        this.screen_data = screen_data
        this.invoiceable_repository = invoiceable_repository
        this.file_repo = file_repo
    }

    async mountList(company_id: Number) {
        console.log('mountList')
        let hasActiveContract = await this.companyHasActiveEinvoiceContract(company_id)
        this.screen_data.hasActiveContract = hasActiveContract
        this.screen_data.setLoading(true)
        let args = {}
        args['company_id'] = company_id
        args['sort_by'] = this.screen_data.sort_by
        args['limit'] = this.screen_data.limit
        args['offset'] = this.screen_data.offset
        args['filters'] = {}
        Object.values(this.screen_data.availableFilters).forEach(element => {
            if (element.name === 'info_third') {
                args['info_third'] = element.value;
            } else if (element.value) {
                args['filters'][element.name] = element.value;
            }
        });
        let res = await this.recurring_invoice_repository.filter_recurring_invoices(args)
        this.screen_data.setRecurringInvoices(res.results)
        this.screen_data.setTotalItems(res.count)
        this.screen_data.setLoading(false)
        this.screen_data.selectedItems = []
    }

    updateFilters(params) {
        Object.values(this.screen_data.availableFilters).forEach(element => {
            if (params.key === element.name) {
                element.value = params.value;
                element.text = params.text;
            }
        });
    }

    celanAllFilters() {
        Object.values(this.screen_data.availableFilters).forEach(element => {
            element.value = '';
            element.text = '';
        });
        this.screen_data.offset = 0
    }

    async generateInvoiceFromContract() {
        console.log('generateInvoiceFromContract')
        this.screen_data.setLoading(true)
        let selectedIds = this.screen_data.selectedItems.map(item => item.id)
        if (selectedIds.length == 0) {
            this.screen_data.errorMessage('No hay contratos seleccionados')
            this.screen_data.setLoading(false)
            return
        }
        else if (selectedIds.length > 1) {
            this.screen_data.errorMessage('Solo se puede forzar la generación de una contrato a la vez')
            this.screen_data.setLoading(false)
            return
        }
        try {
            await this.recurring_invoice_repository.createinvoiceFromContract(selectedIds[0])
            this.screen_data.successMessage('Proceso de generación de factura iniciado')
        } catch (e) {
            this.screen_data.errorMessage('Hubo un error al generar la factura')
        }
        this.screen_data.setLoading(false)
    }

    async deleteContracts() {
        console.log('deleteContract')
        this.screen_data.setLoading(true)
        let selectedIds = this.screen_data.selectedItems.map(item => item.id)
        if (selectedIds.length == 0) {
            this.screen_data.errorMessage('No hay contratos seleccionados')
            this.screen_data.setLoading(false)
            return
        }
        if (this.screen_data.selectedItems.some(item => item.state == 'started')) {
            this.screen_data.errorMessage('No se pueden eliminar contratos que estén en curso')
            this.screen_data.setLoading(false)
            return
        }
        let res = await this.recurring_invoice_repository.delete(selectedIds)
        if (res['status'] == 'ok') {
            this.screen_data.successMessage('Contratos eliminados')
        } else {
            this.screen_data.errorMessage('Hubo un error al eliminar los contratos')
        }
        this.screen_data.setLoading(false)
        
    }

    async companyHasActiveEinvoiceContract(company_id) {
        return await this.invoiceable_repository.company_has_active_einvoice_contract(company_id)
    }

    async importRecurringInvoicesFromExcel(company_id: number, file: File) {
        this.screen_data.setLoading(true)
        try {
            // Upload file to S3
            let path = await this.file_repo.uploadFile(file)
            console.log('File uploaded to:', path)

            // Call the import function from the repository
            let res = await this.recurring_invoice_repository.import_recurring_invoice_from_excel(path, company_id)

            if (res.output === true) {
                this.screen_data.successMessage('Archivo procesado correctamente')
            }
            else {
                this.screen_data.errorMessage(res.output)
            }
            // Reload the list to show new recurring invoices
            await this.mountList(company_id)
        } catch (e) {
            console.error('Error importing recurring invoices from Excel:', e)
            this.screen_data.errorMessage('Hubo un error al procesar el archivo')
        }
        this.screen_data.setLoading(false)
    }

    async adjustBasesByPercent(adjustPercent: number) {

        this.screen_data.setLoading(true)
        const selectedIds = this.screen_data.selectedItems.map(item => item.id)

        let res = await this.recurring_invoice_repository.adjust_bases_by_percent(selectedIds, adjustPercent)
        this.screen_data.setLoading(false)
        if (res != null && res.hasOwnProperty('status') && res['status'] == 'ok') {
            this.screen_data.successMessage('Bases y precios actualizados')
        } else {
            this.screen_data.errorMessage('Hubo un error al ajustar bases y precios')
        }
    }

    async adjustBasesByFixed(adjustValue: number) {
        
        this.screen_data.setLoading(true)
        const selectedIds = this.screen_data.selectedItems.map(item => item.id)
        
        let res = await this.recurring_invoice_repository.adjust_bases_by_fixed(selectedIds, adjustValue)
        this.screen_data.setLoading(false)
        if (res != null && res.hasOwnProperty('status') && res['status'] == 'ok') {
            this.screen_data.successMessage('Bases y precios actualizados')
        } else {
            this.screen_data.errorMessage('Hubo un error al ajustar bases y precios')
        }
    }
}